<template>
  <div class="fd-w-full fd-bg-white fd-rounded-lg fd-px-4 fd-py-6" style="min-height: 500px;">
    <Table
      :name="name"
      :total="total"
      :fields="fields"
      :items="phases"
      :hasFilter="false"
      :hasSearch="true"
      :perPage="10"
      :isBusy="isBusy"
      @changedPage="setPage"
      @setSearch="setSearch"
      @showRemoveComponent="showRemoveComponent"
      @showEditComponent="editPhase"
    />
    <ConfirmDialogue @remove="removePhase" />
  </div>
</template>

<script>
import Table from "@/views/components/global/Table";
import {mapGetters} from "vuex";
import {bus} from "@/main";
import toast from "@/mixins/toast";
import ConfirmDialogue from "@/views/components/global/ConfirmDialogue";
export default {
  name: "Phases",
  components: {ConfirmDialogue, Table},
  mixins: [toast],
  data() {
    return {
      loading: false,
      btnTitle: null,
      search: '',
      itemId: null
    }
  },
  created() {
    this.btnTitle = this.$route.meta.button.btnTitle
    bus.$on(this.btnTitle, () => {
      this.createNewPhase()
    })
    let data = {
      id: this.$route.params.id
    }
    this.getData(data)
  },
  watch: {
    search: {
      handler(newVal) {
        let data = {
          id: this.$route.params.id,
        }
        if (newVal) {
          data.search = newVal
        }
        this.getData(data)
      }
    }
  },
  computed: {
    ...mapGetters({
      phases: 'project/phases',
      total: 'project/phasesTotal'
    }),
    fields() {
      return [
        {
          key: 'name', label: this.$t('table.name'),
          sortable: true,
          sortDirection: 'desc',
          clickable: true,
          thStyle: { minWidth: '50px !important' }
          },
        { key: 'description', label: this.$t('table.description'), thStyle: { minWidth: '140px !important' } },
        { key: 'properties_count', label: this.$t('table.property'), thStyle: { minWidth: '100px !important' } },
        {
          key: 'delivery_date',
          label: this.$t('table.deliveryTime'),
          thStyle: { minWidth: '50px !important' }
        },
        { key: 'actions', label: this.$t('table.actions'), class: 'text-right' }
      ]
    },
    name() {
      return this.$t('phases.phases')
    },
    isBusy() {
      return this.loading
    }
  },
  methods: {
    getData(data) {
      this.loading = true

      this.$store.dispatch('project/getPhases', data).finally(() => {
        this.loading = false
      })
    },
    setFilters(filters) {
      console.log(filters)
    },
    setPage(number) {
      let data = {
        id: this.$route.params.id,
        number
      }
      if (this.search) {
        data.search = this.search
      }
      this.getData(data)
    },
    setSearch(search) {
      this.search = search
    },
    createNewPhase() {
      this.$store.dispatch('project/createNewPhase', this.$route.params.id).then(() => {
        this.makeToast(this.$t('toastMessages.phaseCreated'))
        let data = {
          id: this.$route.params.id,
        }
        if (this.search) {
          data.search = this.search
        }
        this.getData(data)
      })
    },
    removePhase() {
      this.$store.dispatch('project/removePhase', this.itemId).then(() => {
        this.makeToast(this.$t('toastMessages.phaseDeleted'))
        let data = {
          id: this.$route.params.id,
        }
        if (this.search) {
          data.search = this.search
        }
        this.getData(data)
      })
      .finally(() => {
        this.itemId = null
        this.toggleConfirmDialogue()
      })
    },
    showRemoveComponent(id) {
      this.itemId = id
      this.toggleConfirmDialogue()
    },
    toggleConfirmDialogue() {
      this.$root.$emit("bv::toggle::modal", "confirmDialogue");
    },
    editPhase(id) {
      this.$router.push({ name: 'phases.show', params: { id } })
    }
  },
  beforeDestroy() {
    bus.$off(this.btnTitle)
  },
}
</script>

<style scoped>

</style>